module.exports = __webpack_public_path__ + "img/02.5c56dd22.jpg";